module.exports = __webpack_public_path__ + "static/img/2_3_3.571211d5.jpg";